import React from 'react'
import VideoPlayer from '../../VideoPlayer'
import SimpleLink from '../../SimpleLink'
import { translate } from 'react-i18next'
import { Routes } from '../../../utils/constants'
import './index.sass'

const VideoContent = ({ video, title, text, lng, t }) => {
  return (
    <div className="video-content">
      <h4 className="subtitle-1">{title}</h4>
      <div className="audio-video-content">
        <p className="body-light">{text}</p>
        <VideoPlayer videoUrl={video.videoUrl} />
      </div>
      <SimpleLink
        route={lng === 'en' ? Routes.WORK : `/${lng}${Routes.WORK}`}
        text={t('navigations.portfolio')}
      />
    </div>
  )
}

export default translate('translations')(VideoContent)
